import {
  showMessage,
  logMessage,
  debounce,
  start,
  end,
  getResponseByMode,
  isError
} from './utils';
import {
  dialog
} from '../base';
import {
  updateBasket
} from './basket';
import {
  ProductCounter
} from './product-counter';

export function updateBasketFromList() {
  const lists = document.querySelectorAll('.category__list');

  if (lists === null) {
    return;
  }

  lists.forEach((list) => {
    list.addEventListener('click', listClickHandler);
  });

  function listClickHandler(evt) {
    if (evt.target.classList.contains('view__button--cart') && !evt.target.classList.contains('view__button--added') && !evt.currentTarget.classList.contains('recommended__list')) {
      evt.preventDefault();
      const cartButton = evt.target;
      start();
      whenListProductDataLoad(cartButton);
    }
    if (evt.target.closest('.starx')) {
      evt.preventDefault();
      const favoriteButton = evt.target.closest('.starx');
      start();
      whenFavoriteDataLoad(favoriteButton);
    }
  }
}

export function updateBasketFromProduct() {
  const sectionAboutProduct = document.querySelector('.about-product');
  const favoriteButton = sectionAboutProduct.querySelector('.starx');
  const formProduct = sectionAboutProduct.querySelector('#form-product');
  const formControls = new ProductCounter(formProduct);

  formControls.clickHandler(formProductClickAndSubmittHandler);
  favoriteButton.addEventListener('click', favoriteButtonClickHandler);

  function favoriteButtonClickHandler(evt) {
    evt.preventDefault();
    start();
    whenFavoriteDataLoad(evt.currentTarget);
  }

  function formProductClickAndSubmittHandler() {
    start();
    whenProductDataLoad();
  }
}

const whenListProductDataLoad = debounce(function (elem) {
  const mock = 'mocks/product.json';

  const loadUrl = new URL(elem.href);
  loadUrl.searchParams.set('ajax', 1);
  loadUrl.searchParams.set('related', 1);
  const real = loadUrl.href;

  const url = getResponseByMode(mock, real);

  fetch(url)
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error(`Не получилось добавить товар в корзину`);
    })
    .then((data) => {
      isError(data);
      isGift(data);
      return data.count;
    })
    .then((count) => {
      updateBasket(count);
      updateCartButton(elem);
      showMessage('Товар добавлен в корзину', 'success');
    })
    .catch((error) => {
      console.warn(error);
      logMessage(error);
      showMessage(error.message);
    })
    .finally(() => end());
});

function updateCartButton(elem) {
  elem.classList.add('view__button--added');
  elem.textContent = 'В корзине';
  elem.href = '/shop/cart/';
}

const whenFavoriteDataLoad = debounce(function (elem) {
  const mock = 'mocks/product.json';

  const loadUrl = new URL(elem.href);
  loadUrl.searchParams.set('ajax', 1);
  const real = loadUrl.href;

  const url = getResponseByMode(mock, real);

  fetch(url)
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error(`Не получилось добавить товар в Избранное`);
    })
    .then((data) => {
      isError(data);
      elem.classList.toggle('starx--active');

      if (elem.classList.contains('starx--active')) {
        showMessage('Товар добавлен в Избранное', 'success');
      }
    })
    .catch((error) => {
      console.warn(error);
      logMessage(error);
      showMessage(error.message);
    })
    .finally(() => end());
});

const whenProductDataLoad = debounce(function (redirect = false) {

  const mock = {
    url: 'mocks/product.json',
    options: {
      method: 'GET',
    }
  };

  const form = document.querySelector('#form-product');
  const formData = new FormData(form);
  const loadUrl = new URL(form.action);
  loadUrl.searchParams.set('ajax', 1);

  const real = {
    url: loadUrl.href,
    options: {
      method: 'POST',
      body: formData
    }
  };

  const {
    url,
    options
  } = getResponseByMode(mock, real);

  fetch(url, options).then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error(`Не получилось добавить товар в корзину`);
    })
    .then((data) => {
      isError(data);
      isGift(data);
      return data.count;
    })
    .then((count) => {
      updateBasket(count);
      if (redirect) {
        location.pathname = '/shop/checkout/';
        return;
      }
    })
    .catch((error) => {
      console.warn(error);
      logMessage(error);
      showMessage(error.message);
    })
    .finally(() => end());
});

function isGift(data) {
  if (data.surprize) {
    dialog.open('surprize')
      .then((obj) => {
        const modal = obj.getElem();
        const elem = modal.querySelector('.dialog__surprize');
        elem.textContent = data.name || 'Этот товар';
      });
  }
}
